import { Box, Modal } from "@mui/material"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { MyDispatch, MySelector } from "../../redux/store"
import copyIcon from "../../assets/photo/copy.svg"
import copyIconDark from "../../assets/photographer/copy_dark.svg"
import { handleCopyClick } from "../../utils/copyLink"
import { HandleAsyncFns } from "../../hooks/handleAsyncFns"
import { setShareFile } from "../../redux/utilSlice"
import { desc, returnStyle, title } from "../../utils/popupModalStyle"

const ShareModal = () => {
  const dispatch = useDispatch<MyDispatch>()

  const { shareFile: shareLink } = MySelector((state) => state.util)

  const [showModal, setShowModal] = useState(false)

  const { shareFile } = HandleAsyncFns()
  const { theme } = MySelector((state) => state.theme)

  // to toggle the modal
  useEffect(() => {
    if (!shareLink) setShowModal(false)
    else setShowModal(true)
  }, [shareLink])

  return (
    <Modal
      open={showModal}
      onClose={() => {
        setShowModal(false)
        dispatch(setShareFile(null))
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={returnStyle(theme)}>
        <div className="px-4 py-5 md:px-[26.11px] md:py-[33.25px]">
          <p className={title}>Share Link</p>
          <p className={desc} style={{ textAlign: "start", marginTop: "10px" }}>
            Copy Link
          </p>
          <div className="flex items-center justify-between bg-[#706F6C1A] border-[0.5px] border-[#706F6C80] text-black dark:text-white rounded-lg p-2 md:p-4 mt-2 text-xs md:text-sm">
            <p className="hidden md:block">
              https://itsforeverapp.page.link/{shareLink?.slice(0, 3)}
            </p>
            <p className="md:hidden">
              itsforeverapp.page.link/{shareLink?.slice(0, 3)}
            </p>
            <img
              src={theme === "dark" ? copyIcon : copyIconDark}
              alt=""
              className="cursor-pointer h-4 w-4"
              onClick={() => {
                handleCopyClick(shareFile.shareLink())
                setShowModal(false)
                dispatch(setShareFile(null))
              }}
            />
          </div>
        </div>
      </Box>
    </Modal>
  )
}

export default ShareModal
